import React, { Component } from 'react';
import { connect } from 'react-redux';
import { loginActions } from '../action/loginAction';
import { withTranslation } from 'react-i18next';
import { history } from '../helpers/history';
import { Link } from 'react-router-dom';
import { gameActions } from '../action/GameAction';
import { alertActions } from '../action/AlertAction';
import { appVariables } from '../helpers/appVariables';
import LangSelector from '../Pages/MyAccount/Languageselector';
import IdelSessionTimer from "../IdelSessionTimer";
import Currencyselector from '../Pages/MyAccount/Currencyselector';
import { commonClass } from '../helpers/commonClass';
import LoginNew from '../LoginNew';
import ForgotPasswordMobNo from '../ForgotPasswordMobNo';
import ForgotPasswordOtpNew from '../ForgotPasswordOtpNew';
import EnterForgotPassword from '../EnterForgotPassword';
class Header extends Component {
	constructor(props) {
		super(props);
		const UserCountry = localStorage.getItem('cloc') ? JSON.parse(localStorage.getItem('cloc')) : {};
		const queryParameters = new URLSearchParams(window.location.search)
		const typeForgotpassword = queryParameters.get("resetpassword")
		const typelogin = queryParameters.get("login")
		this.state = {
			settabind: 0,
			fgame: [],
			logoutflog: 0,
			menuID: '',
			CheckIsMy: Object.keys(UserCountry).length > 0 && UserCountry.country && UserCountry.country.toLowerCase() == 'my',
			UserCountry: UserCountry,
			LoginPopup: false,
			Default: 0,
			Forgotpasswordstring: JSON.parse(typeForgotpassword),
			loginstring: JSON.parse(typelogin),
		}
	}

	getbal = () => {
		this.props.getBalance(this.props.user.mobileNo, this.props.i18n.language, this.props.user.loginKey, this.props.user.Country_code)
	}
	showLogin = (lobjloginshow) => {
		this.props.setPage(lobjloginshow);
	};
	showAccount = () => {
		history.push('/myaccount')
	};
	changelink(menuid) {
		this.setState({ settabind: menuid });
	}
	componentDidUpdate() {
		//	window.Loginpopup(this.props.LightBoxID);

	}
	static getDerivedStateFromProps(props, state) {
		return { LightBoxID: props.LightBoxID };
	};
	componentDidMount() {
		let getpopupoption = sessionStorage.getItem('popupopen') ? JSON.parse(sessionStorage.getItem('popupopen')) : [];
		if (getpopupoption && getpopupoption.length > 0) {
			if (getpopupoption == appVariables.PopUpFlags.Login) {
				this.setState({ LoginPopup: true })
				this.state.LoginPopup = true;
				this.setState({ Default: 0 })
			}
			else if (getpopupoption == appVariables.PopUpFlags.Forgotpassword) {
				this.setState({ Default: 2 })
			}
			else if (getpopupoption == appVariables.PopUpFlags.Reenterpassword) {
				this.setState({ Default: 3 })
			}
			sessionStorage.removeItem('popupopen')
		}
		// document.querySelector('.toggle').addEventListener('click', function () {
		// 	this.classList.toggle('activate');
		// });
		this.changeMenu();
		this.FetchNotlocData()
		if (window.ToggleControl) {
			window.ToggleControl();
		}
		// if (window.UserOPtions) {
		// 	window.UserOPtions();
		// }
		// window.GoMyAccount = this.gotoAccount;
		// window.LogoutCall = this.logout(1);
	}
	showMsg = (msg) => {
		this.props.alertError(this.props.t(msg));
	}
	logout = (id) => {
		this.setState({ logoutflog: id });
	}
	mylogout = () => {
		this.props.logout(this.props.user.mobileNo);
	}
	gotoMyCart = () => {
		//due to user can view empty cart.
		//if (this.props.cartItems && this.props.cartItems.length > 0) {
		if (this.props.cartItems && this.props.cartItems.length > 0) {
			history.push('/mycart');
		}
		else {
			this.showMsg(this.props.t('lblCartempty'));
		}
	}
	changeMenu = () => {
		try {
			let myloc = history.location.pathname;
			switch (myloc) {
				case "/home":
					this.setState({ menuID: appVariables.MENU_ID.Home });
					break;
				case "/fortune4":
					this.setState({ menuID: appVariables.MENU_ID.Fortune5 });
					break;
				case "/super6":
					this.setState({ menuID: appVariables.MENU_ID.Super6 });
					break;
				case "/promotion":
					this.setState({ menuID: appVariables.MENU_ID.Promotion });
					break;
				case "/faqs":
					this.setState({ menuID: appVariables.MENU_ID.Faqs });
					break;
				case "/HowtoPlay":
					this.setState({ menuID: appVariables.MENU_ID.HowtoPlay });
					break;
				case "/fortune4draws":
					this.setState({ menuID: appVariables.MENU_ID.Fortune5draw });
					break;
				case "/super6draws":
					this.setState({ menuID: appVariables.MENU_ID.Super6draw });
					break;
				case "/Login":
					this.setState({ menuID: appVariables.MENU_ID.Login });
					break;
				case "/Register":
					this.setState({ menuID: appVariables.MENU_ID.Register });
					break;
				case "/magic5draws":
					this.setState({ menuID: appVariables.MENU_ID.Magic5draw });
					break;
				case "/magic5":
					this.setState({ menuID: appVariables.MENU_ID.Magic5 });
					break;
				case "/othersdraws":
					this.setState({ menuID: appVariables.MENU_ID.Others });
					break;
				case "/winnersstory":
					this.setState({ menuID: appVariables.MENU_ID.PrevDrawVideos });
					break;
				case "/lucky1":
					this.setState({ menuID: appVariables.MENU_ID.Lucky1 });
					break;
				case "/lucky1draws":
					this.setState({ menuID: appVariables.MENU_ID.Lucky1draw });
					break;
				case "/dream5draws":
					this.setState({ menuID: appVariables.MENU_ID.Dream5draw });
					break;
				case "/dream5":
					this.setState({ menuID: appVariables.MENU_ID.Dream5 });
					break;
				case "/rush3":
					this.setState({ menuID: appVariables.MENU_ID.Pick3 });
					break;
				case "/rush3draws":
					this.setState({ menuID: appVariables.MENU_ID.Pick3draw });
					break;
			}
		} catch (ex) { }
	}
	gotoAccount = () => {
		localStorage.removeItem('atabId');
		history.push('/Account');
	}
	gotoprevdraw = (gameID) => {
		localStorage.removeItem('drawtabId');
		if (gameID == 9) {
			history.push('/fortune6draws')
		}
		else if (gameID == 10) {
			history.push('/super6draws')
		}
		else if (gameID == 11) {
			history.push('/magic5draws')
		}
		else if (gameID == 12) {
			history.push('/othersdraws')
		}
		else if (gameID == 13) {
			history.push('/winnersstory')
		}
		else if (gameID == 17) {
			history.push('/lucky1draws')
		}
		else if (gameID == 18) {
			history.push('/dream5draws')
		}
		else if (gameID == 21) {
			history.push('/rush3draws')
		}

	}

	FetchNotlocData = async () => {
		const GeoUserCountry = localStorage.getItem('cloc') ? JSON.parse(localStorage.getItem('cloc')) : {};
		if (Object.keys(GeoUserCountry).length <= 0) {
			let response = await commonClass.GetGeoLocCountry();
			let dataflag = response.country.toLowerCase() == 'my' ? true : false
			this.setState({ CheckIsMy: dataflag })
		}
	}

	PopupOptions = (value) => {
		this.state.Default = value;
		this.setState({ Default: value })
	}

	openLogin = () => {
		this.setState({ LoginPopup: true })
		this.setState({ Default: 0 })
	}
	render() {
		const { t } = this.props;
		return (
			<>
				{this.props.user && this.props.user.mobileNo != "0" && <IdelSessionTimer />}
				<header>
					<div className="wrap1">
						<button id="toggleBtn">☰</button>
						<a className="logo" onClick={() => history.push('/home')}>
							<img src="./assets/img/logo.png?v0.3" alt="GT Logo" />
						</a>
						<div class="loginSec">
							<div class="cart">
								<a class="bg1" onClick={() => { history.push('/mycart') }}	>
									<img src="./assets/img/icons/cart.png" alt="Cart" />
									{this.props.user.mobileNo != "0" && this.props.cartItems && this.props.cartItems.length > 0 && <small>{this.props.cartItems.length}</small>}
								</a>
							</div>
							{this.props.user.freecount > 0 && <div class="cart1" style={{ paddingRight: '10px' }}>
								<a onClick={() => { localStorage.setItem('atabId', 3); history.push('/Account') }}	>
									{t('lblfreecount')} :{this.props.user.freecount}
								</a>
							</div>}

							<LangSelector />
							{/* <Currencyselector /> */}
							{(this.props.user && this.props.user.mobileNo != "0") ?
								<div className="userDetails">
									<div className='userDetailsInner'>
										<div class="userWallet forCursor">
											<img onClick={() => { localStorage.setItem('atabId', 3); history.push('/Account') }} src="./assets/img/icons/wallet.png" alt="wallet" />
											<span onClick={() => { localStorage.setItem('atabId', 3); history.push('/Account') }}>{this.props.appvariables.currency}  {commonClass.aedCrnyConvert(this.props.user.balance)}</span>
											<img onClick={() => { this.getbal() }} src="./assets/img/icons/refresh.png" alt="wallet refresh" />
										</div>
										{/* <div class="userWallet">
											<img src="./assets/img/wallet_add_new_img.webp" alt="wallet" className="w-5 poitner" onClick={() => { localStorage.setItem('atabId', 3); history.push('/Account') }} />
											<img src="./assets/img/icons/refresh.png" alt="wallet refresh" className="w-5 poitner" onClick={() => { this.getbal() }} />
											<span>{this.props.appvariables.currency} {commonClass.aedCrnyConvert(this.props.user.balance)}</span>
										</div> */}
									</div>
									<div class="userWallet userAccHover">
										<img src="./assets/img/icons/profile.png" alt="profile" />
										<span >Hi, {this.props.user.Player_name}</span>
										<img src="./assets/img/icons/down-arrow.png" alt="down-arrow" />
										<div className="dropdown-content">
											<a onClick={() => this.gotoAccount()} >{t('lblMyAccount')}</a>
											<a onClick={() => this.logout(1)} >{t('lblLogout')}</a>
										</div>
									</div>
									{/* <div class="avatar">{this.props.user.Player_name && this.props.user.Player_name.length > 0 ?
										<>{this.props.user.Player_name.charAt(0).toUpperCase()}</> : <p>?</p>
									}</div> */}
									{/* <div className="dropdownMenu">
										<a onClick={() => this.gotoAccount()} style={{ textAlign: "left" }}>{t('lblMyAccount')}</a>
										<a onClick={() => this.logout(1)} style={{ textAlign: "left" }}>{t('lblLogout')}</a>
									</div> */}
								</div>
								:
								<div class="loginReg">
									<img src="./assets/img/icons/user.png" />
									{/* <a onClick={() => history.push('/Login')} className="">{t('lblLogin')}</a> */}
									<a className="signIn" onClick={() => { this.openLogin() }}>{t('lblLogin')}</a>
									<a onClick={() => history.push('/Register')} className="" > /  {t('lblRegister')}</a>
									{this.props.user && this.props.user.mobileNo == 0 && this.state.CheckIsMy && <a href={process.env.REACT_APP_AGENT_URL} target="_blank" className="newUser activeSignup becameAgent" dangerouslySetInnerHTML={{ __html: t(`lblbecameage`) }}></a>}
								</div>

							}
						</div>
					</div>
				</header >
				{this.state.logoutflog != 0 &&
					// this.state.logoutflog != 0 && <>
					// 	<div style={{ transform: "translate(-50%, -50%)", display: "block" }} className="lightbox AlertpopUp">
					// 		<div className="lightBox-wrap">
					// 			<div className="userContent">
					// 				<h2 style={{ padding: "10px" }}>{t('lblAreYousureLogout')}</h2>
					// 				<div className="altBtns">
					// 					<button className="bg6" onClick={() => { this.mylogout() }}>{t('lblYes')}</button>
					// 					<button className="bg10" onClick={() => { this.logout(0) }}>{t('lblNo')}</button>
					// 				</div>
					// 			</div>
					// 		</div>
					// 	</div>
					// 	<div className="overlaybetsilp" style={{ display: "block" }}></div></>
					<>
						<div class="messageBox" style={{ transform: "translate(-50%, -50%)", display: "block" }}>
							<div class="messageBoxWrap">
								<p style={{ padding: "10px" }}>{t('lblAreYousureLogout')}</p>
								<div>
									<button onClick={() => { this.mylogout() }}>{t('lblYes')}</button>
									<button onClick={() => { this.logout(0) }}>{t('lblNo')}</button>
								</div>
							</div>
						</div>
						<div class="overlayMessage" style={{ display: "block" }}></div>
					</>
				}

				{/* 1 = login,2=EnterMobileNumber,3=Enter Otp,4=ChangePassword*/}
				{this.state.LoginPopup && this.state.Default == 0 ?
					<LoginNew getflag={(value) => { this.PopupOptions(value) }} /> :
					this.state.Default == 1 ? <ForgotPasswordMobNo getflag={(value) => { this.PopupOptions(value) }} /> :
						this.state.Default == 2 ? <ForgotPasswordOtpNew getflag={(value) => { this.PopupOptions(value) }} /> :
							this.state.Default == 3 ? <EnterForgotPassword getflag={(value) => { this.PopupOptions(value) }} /> : <></>
				}
			</>
		);
	}
}
function mapStateToProps(state) {
	const { user, LightBoxID, appvariables } = state.loginReducer;
	const { cartItems } = state.gameReducer;
	return { user, LightBoxID, cartItems, appvariables };
}
const mapActionToProps = {
	login: loginActions.login,
	setPage: loginActions.setPage,
	getBalance: loginActions.getBalance,
	SetGameFamily: gameActions.SetGameFamily,
	alertError: alertActions.error,
	logout: loginActions.logout
}
export default connect(mapStateToProps, mapActionToProps)(withTranslation()(Header))
